module.exports = __webpack_public_path__ + "img/osCommerce.b6e4927.svg";